import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import CarCard from "@/components/CarCard";

export default function FeaturedCars() {
    const [cars, setCars] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/cars", { params: { featured: true, limit: 6 } })
            .then((res) => setCars(res.data))
            .finally(() => setLoading(false));
    }, []);

    return (
        <section
            id="inventory"
            className="relative py-28 lg:py-36 overflow-hidden"
            data-testid="featured-cars-section"
        >
            <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[60rem] h-[60rem] rounded-full blur-3xl opacity-30 pointer-events-none"
                 style={{ background: "radial-gradient(circle, rgba(200,165,90,0.12), transparent 70%)" }} />

            <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
                <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-16 gap-6">
                    <div>
                        <motion.span
                            initial={{ opacity: 0, y: 12 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6 }}
                            className="block text-gold text-[11px] uppercase tracking-[0.32em] mb-5"
                        >
                            Селекция
                        </motion.span>
                        <motion.h2
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.7 }}
                            className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tightest"
                            data-testid="featured-cars-title"
                        >
                            Препоръчани автомобили
                        </motion.h2>
                    </div>
                    <motion.p
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                        className="max-w-md text-ink-muted leading-relaxed"
                    >
                        Внимателно подбрана колекция от премиум автомобили — всеки преминал през
                        пълна диагностика, проверка на историята и експертна оценка.
                    </motion.p>
                </div>

                {loading ? (
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
                        {[...Array(6)].map((_, i) => (
                            <div
                                key={i}
                                className="aspect-[4/5] bg-surface rounded-2xl border border-line animate-pulse"
                            />
                        ))}
                    </div>
                ) : (
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
                        {cars.map((car, i) => (
                            <CarCard key={car.id} car={car} index={i} />
                        ))}
                    </div>
                )}

                <div className="mt-14 text-center">
                    <a
                        href="/cars"
                        data-testid="featured-cars-view-all"
                        className="inline-flex items-center gap-3 border border-gold/50 hover:border-gold hover:bg-gold/10 text-gold px-8 py-4 rounded-full transition-all"
                    >
                        Виж всички автомобили
                        <span>→</span>
                    </a>
                </div>
            </div>
        </section>
    );
}
